import { useCallback, useState } from 'react';
import useDatafeedMessageEffect from '../useDatafeedMessageEffect';
import { UseLivePriceKey, UseLivePriceRes } from './useLivePrice.types';
import { natsLivePriceFormatter } from './useLivePrice.utils';
import { UseLivePriceOnMessage } from './useLivePriceReceiver';

export const useLivePriceSingleReceiver = (
  symbol: string,
  key: UseLivePriceKey,
  onMessage?: UseLivePriceOnMessage,
) => {
  const [livePrice, setLivePrice] = useState<UseLivePriceRes>();

  const handleReceiveMessage = useCallback(
    async (message: DatafeedMessageChannel) => {
      const { liveprice } = message || {};
      if (liveprice && symbol === liveprice.stockCode) {
        const formattedLivePrice = natsLivePriceFormatter(liveprice);
        if (onMessage) onMessage(formattedLivePrice, liveprice);
        setLivePrice(formattedLivePrice);
      }
    },
    [symbol, onMessage],
  );

  // Nats Socket Receiver
  useDatafeedMessageEffect(
    'liveprice',
    `${key}:${symbol}`,
    handleReceiveMessage,
  );

  return { livePrice };
};
